import thunk from "redux-thunk";
import { createStore, applyMiddleware, compose } from "redux";
import { reducers } from "../ducks";

/* ------------- Redux Configuration ------------- */
const middleware = [];
const enhancers = [];

/* ------------- Logger Middleware ------------- */
middleware.push(thunk);

/* ------------- Assemble Middleware ------------- */
enhancers.push(applyMiddleware(...middleware));

/* ------------- Apply REDUX Dev tools ------------- */
const composeEnhancers =
  (typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
  compose;

/* ------------- Create Store ------------- */
const enhancer = composeEnhancers(...enhancers);
const store = createStore(reducers, {}, enhancer);

export { store };
